/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Tracking Icon component.
 */
export const SideNavTrackingIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_16189_26964)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M23.1956 10.9688L21.8831 7.6875C21.6553 7.11944 21.1039 6.74789 20.4919 6.75H17.25V6C17.25 5.58579 16.9142 5.25 16.5 5.25H2.25C1.42157 5.25 0.75 5.92157 0.75 6.75V17.25C0.75 18.0784 1.42157 18.75 2.25 18.75H3.84375C4.18363 20.0774 5.37974 21.0059 6.75 21.0059C8.12026 21.0059 9.31637 20.0774 9.65625 18.75H14.3438C14.6836 20.0774 15.8797 21.0059 17.25 21.0059C18.6203 21.0059 19.8164 20.0774 20.1562 18.75H21.75C22.5784 18.75 23.25 18.0784 23.25 17.25V11.25C23.2503 11.1536 23.2318 11.0581 23.1956 10.9688ZM17.25 8.25H20.4919L21.3919 10.5H17.25V8.25ZM2.25 6.75H15.75V12.75H2.25V6.75ZM6.75 19.5C5.92157 19.5 5.25 18.8284 5.25 18C5.25 17.1716 5.92157 16.5 6.75 16.5C7.57843 16.5 8.25 17.1716 8.25 18C8.25 18.8284 7.57843 19.5 6.75 19.5ZM14.3438 17.25H9.65625C9.31637 15.9226 8.12026 14.9941 6.75 14.9941C5.37974 14.9941 4.18363 15.9226 3.84375 17.25H2.25V14.25H15.75V15.4041C15.0534 15.8067 14.547 16.4715 14.3438 17.25ZM17.25 19.5C16.4216 19.5 15.75 18.8284 15.75 18C15.75 17.1716 16.4216 16.5 17.25 16.5C18.0784 16.5 18.75 17.1716 18.75 18C18.75 18.8284 18.0784 19.5 17.25 19.5ZM21.75 17.25H20.1562C19.8124 15.9261 18.6179 15.0013 17.25 15V12H21.75V17.25Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_16189_26964'>
          <rect width='24' height='24' fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavTrackingIcon;
